import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { nextTick, onBeforeUnmount, ref, watch } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import GateLoginPanel from '@/components/auth/GateLoginPanel.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallLoginModal',
  props: {
    open: { type: Boolean },
    redirectTo: {}
  },
  emits: ["close", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const panelRef = ref<HTMLElement | null>(null)
const closeRef = ref<HTMLButtonElement | null>(null)
let previousOverflow = ''
let scrollLocked = false

function onKeydown(event: KeyboardEvent) {
  if (!props.open) return
  if (event.key === 'Escape') {
    event.preventDefault()
    emit('close')
    return
  }
  if (event.key !== 'Tab' || !panelRef.value) return

  const focusable = Array.from(
    panelRef.value.querySelectorAll<HTMLElement>(
      'button:not(:disabled), a[href], input:not(:disabled), [tabindex]:not([tabindex="-1"])',
    ),
  )
  if (!focusable.length) return

  const first = focusable[0]
  const last = focusable[focusable.length - 1]
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault()
    last.focus()
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault()
    first.focus()
  }
}

watch(
  () => props.open,
  async (open) => {
    if (open) {
      previousOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'
      scrollLocked = true
      document.addEventListener('keydown', onKeydown)
      await nextTick()
      closeRef.value?.focus()
      return
    }
    if (scrollLocked) {
      document.body.style.overflow = previousOverflow
      scrollLocked = false
    }
    document.removeEventListener('keydown', onKeydown)
  },
)

onBeforeUnmount(() => {
  if (scrollLocked) document.body.style.overflow = previousOverflow
  document.removeEventListener('keydown', onKeydown)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "mall-login-modal" }, {
      default: _withCtx(() => [
        (__props.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "mall-login-modal",
              role: "presentation",
              onMousedown: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (emit('close')), ["self"]))
            }, [
              _createElementVNode("section", {
                ref_key: "panelRef",
                ref: panelRef,
                class: "mall-login-modal__panel",
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "gate-login-title"
              }, [
                _createElementVNode("button", {
                  ref_key: "closeRef",
                  ref: closeRef,
                  type: "button",
                  class: "mall-login-modal__close",
                  "aria-label": "로그인 창 닫기",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
                }, [
                  _createVNode(AppIcon, {
                    icon: "mdi-close",
                    size: 22
                  })
                ], 512),
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mall-login-modal__eyebrow" }, "HAMWOORI MALL", -1)),
                _createVNode(GateLoginPanel, {
                  context: "mall",
                  "redirect-to": __props.redirectTo,
                  onSuccess: _cache[1] || (_cache[1] = ($event: any) => (emit('success')))
                }, null, 8, ["redirect-to"]),
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mall-login-modal__note" }, " 장기요양지원센터 ", -1))
              ], 512)
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})